var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home pt-5"},[_c('BannerMultiProductComponent',{staticClass:"mt-1",attrs:{"background":"#00308F","height":"500px","lang":"en","country":"usa","items":_vm.banner_items}}),_c('modalPopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }